__turbopack_context__.v({
  "animate": "spinning-loader-module-scss-module__OC2g-a__animate",
  "container": "spinning-loader-module-scss-module__OC2g-a__container",
});
